export default __webpack_public_path__ + "static/media/7.9ca1a254.svg";